import React from 'react';
import '../ConfirmWindow/ConfirmationWindow.scss';
import './AiDisclaimer.scss';
import {Bot} from 'lucide-react';
import Button from "../../ui/Button/Button";

interface AiDisclaimerProps {
    personName?: string;
    onAccept: () => void;
    onDecline: () => void;
}

const AiDisclaimer = ({personName, onAccept, onDecline}: AiDisclaimerProps) => {
    return (
        <div className="ConfirmWindow" role="dialog" aria-modal="true" aria-labelledby="aiDisclaimerTitle">
            <div className="ConfirmWindow__blur"></div>

            <div className="ConfirmWindow__form AiDisclaimer">
                <div className="row">
                    <div className="icon-tile icon-tile--gradient"><Bot size={20}/></div>
                    <h2 id="aiDisclaimerTitle">You are talking to an AI</h2>
                </div>

                <ul>
                    <li>This chat is an <strong>AI simulation</strong>{personName ? ` of ${personName}` : ''}, created
                        from the chat history and voice sample you uploaded. It is <strong>not the real
                            person</strong>.
                    </li>
                    <li>Replies and voice messages are generated automatically. They may be inaccurate, made up, or
                        upsetting, and they do not reflect what the real person thinks or would say.
                    </li>
                    <li>This is not therapy. If you are struggling, please reach out to people you trust or a
                        professional. In a crisis, contact your local emergency number.
                    </li>
                    <li>Never use generated messages or voice to impersonate this person to anyone else.</li>
                </ul>

                <a href="/terms" target="_blank" rel="noopener noreferrer">Read the Terms of Service</a>

                <div className="row buttonsRow">
                    <Button type={'button'} onClick={onDecline} variant={'secondary'} title={'Go back'}/>
                    <Button type={'button'} onClick={onAccept} variant={'primary'} title={'I understand'}/>
                </div>
            </div>
        </div>
    );
};

export default AiDisclaimer;
